const TermsandConditons = [
  {
    id: "2",
    title: "Content Ownership",
    description:
      "All content, including but not limited to blogs, projects, and product showcases, are owned by the portfolio owner. Unauthorized use, copying, or distribution of the content without explicit permission is prohibited.",
  },
  {
    id: "4",
    title: "Third-Party Links",
    description:
      "This portfolio may contain links to external websites or services not owned or controlled by the portfolio owner. The owner is not responsible for the content or practices of these third-party sites.",
  },
  {
    id: "5",
    title: "Use of Services",
    description:
      "Services offered through this portfolio, such as frontend, backend, accounts, and data analytics, are provided as per the terms agreed upon at the time of service booking. The portfolio owner reserves the right to modify or discontinue any service without prior notice.",
  },
  {
    id: "6",
    title: "Privacy Policy",
    description:
      "Any personal information collected through the website, such as via contact forms or service requests, will be handled in accordance with the privacy policy. Your data will not be shared or sold to third parties without your consent.",
  },
  {
    id: "7",
    title: "Limitations of Liability",
    description:
      "The portfolio owner will not be liable for any damages resulting from the use or inability to use the website or its services. This includes, but is not limited to, errors, interruptions, or data loss.",
  },
  {
    id: "8",
    title: "Governing Law",
    description:
      "These terms and conditions are governed by the laws applicable in the country/state of residence of the portfolio owner.",
  },
];
const HeadingTerms = [
  {
    id: "1",
    title: "Introduction",
    description:
      "All content, including but not limited to blogs, projects, and product showcases, are owned by the portfolio owner. Unauthorized use, copying, or distribution of the content without explicit permission is prohibited.",
  },
];


const Alias = [
        {
        title: 'User Submissions',
        description: 'If this portfolio includes user submission features (e.g., comments, inquiries), the following applies:',
        alies: 'By submitting content, you grant the portfolio owner permission to display and use the content.',
        alies1: 'You must not submit any content that is unlawful, offensive, or infringes on intellectual property rights.',
    }
]

export { HeadingTerms, TermsandConditons, Alias };
